import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { MESSAGE_TYPES } from 'types/globalMessaging'
import { showMessage } from 'utils/actions/globalMessaging'
import { ENDPOINTS } from 'utils/api/callApi'
import { selectTransfixLaneError } from 'apps/marketplace/store/transfixLane'
import { IMarketplaceStore } from 'apps/marketplace/store/types'

export enum TRANSFIX_LANE_ACTION_TYPES {
  UPDATE_ASSIGN_LANE_REQUEST = 'UPDATE_ASSIGN_LANE_REQUEST',
  UPDATE_ASSIGN_LANE_SUCCESS = 'UPDATE_ASSIGN_LANE_SUCCESS',
  UPDATE_ASSIGN_LANE_FAILURE = 'UPDATE_ASSIGN_LANE_FAILURE',
  DELETE_LANE_REQUEST = 'DELETE_LANE_REQUEST',
  DELETE_LANE_SUCCESS = 'DELETE_LANE_SUCCESS',
  DELETE_LANE_FAILURE = 'DELETE_LANE_FAILURE',
  CLEAR_LANE_ERRORS = 'CLEAR_LANE_ERRORS',
  EDIT_LANE_ASSIGNMENT = 'EDIT_LANE_ASSIGNMENT',
}

interface ILaneManagerPayload {
  transfixLaneId: string
  userId: string
}

const filterActionsByPrefix = (prefix: string) =>
  Object.keys(TRANSFIX_LANE_ACTION_TYPES).filter((str: string) => str.startsWith(prefix))

export const saveLaneAssignment = (laneManagerAssignment: ILaneManagerPayload) => {
  const requestData = {
    endpoint: ENDPOINTS.laneManagerAssignments,
    method: 'POST',
    body: { laneManagerAssignment },
  }

  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: filterActionsByPrefix('UPDATE'),
    },
  }
}

interface IOnSuccessDispatch {
  type: string
}

export const deleteLaneAssignment = (laneAssignId: string, onSuccess?: IOnSuccessDispatch) => {
  const requestData = {
    endpoint: ENDPOINTS.laneManagerAssignments,
    method: 'DELETE',
    id: laneAssignId,
  }

  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: filterActionsByPrefix('DELETE'),
    },
    onSuccess,
  }
}

interface IEditLaneParams {
  updateLaneId: string
  transfixLaneId: string
  newUserId: string
}

export const editLaneAssignment = ({
  newUserId,
  transfixLaneId,
  updateLaneId,
}: IEditLaneParams) => (dispatch: ThunkDispatch<IMarketplaceStore, undefined, Action>) => {
  dispatch({ type: TRANSFIX_LANE_ACTION_TYPES.EDIT_LANE_ASSIGNMENT })
  dispatch(
    deleteLaneAssignment(updateLaneId, saveLaneAssignment({ transfixLaneId, userId: newUserId }))
  )
}

export const clearLaneAssignmentErrors = () => ({
  type: TRANSFIX_LANE_ACTION_TYPES.CLEAR_LANE_ERRORS,
})

export const postLaneAssignedAction = () => (
  dispatch: ThunkDispatch<IMarketplaceStore, undefined, Action>,
  getState: () => IMarketplaceStore
) => {
  const state = getState()
  const hasErrors = selectTransfixLaneError(state)

  if (hasErrors) dispatch(clearLaneAssignmentErrors())

  dispatch(
    showMessage('Your changes have been saved.', {
      type: MESSAGE_TYPES.info,
      typeLabel: 'Success! ',
      closeDelay: 3000,
    })
  )
}
